import React from 'react'
import { IconButton } from '../IconButton/IconButton.jsx'

/**
 * Inline banner for page-level feedback.
 *
 * Props:
 *   - tone: 'error' | 'info' | 'warning' | 'success'  (default 'info')
 *   - icon: optional ReactNode rendered to the left of the message
 *   - dismissible: when true, renders a × button that calls onDismiss
 *   - onDismiss: () => void
 *   - role: defaults to 'alert' for error/warning, otherwise 'status'
 *   - children: the message
 */
export function Banner({
  tone = 'info',
  icon,
  dismissible = false,
  onDismiss,
  role,
  className = '',
  children,
  ...rest
}) {
  const computedRole = role || (tone === 'error' || tone === 'warning' ? 'alert' : 'status')
  const classes = ['banner', `banner--${tone}`, className].filter(Boolean).join(' ')
  return (
    <div className={classes} role={computedRole} data-tone={tone} {...rest}>
      <div className="banner__body">
        {icon ? <span className="banner__icon" aria-hidden="true">{icon}</span> : null}
        <span>{children}</span>
      </div>
      {dismissible ? (
        <IconButton ariaLabel="Dismiss" onClick={onDismiss} className="banner__dismiss">
          ×
        </IconButton>
      ) : null}
    </div>
  )
}
